import React, { Component } from 'react';
import PropTypes from 'prop-types';

class DropdownOption extends Component {
  constructor(props) {
    super(props);
    this.onClick = this.onClick.bind(this);
    this.setHighlighted = this.setHighlighted.bind(this);
    this.resetHighlighted = this.resetHighlighted.bind(this);
  }
  
    onClick(event){
        const { onSelect, onClick, value, disabled } = this.props;
        if (!disabled) {
          if (onSelect) {
            onSelect(value);
          }
          if (onClick) {
            event.stopPropagation();
            onClick(value);
          }
        }
      };
    
      setHighlighted() {
        const { setHighlighted, index } = this.props;
        setHighlighted(index);
      };
    
      resetHighlighted () {
        const { setHighlighted } = this.props;
        setHighlighted(-1);
      };
    
      render() {
        const {
          children,
          active,
          disabled,
          highlighted,
          title,
        } = this.props;
        return (
          <li style={{textTransform: 'none'}}
            className={`rdw-dropdownoption-default${active ? ' rdw-dropdownoption-active' : ''}${highlighted ? ' rdw-dropdownoption-highlighted' : ''}${disabled ? 'rdw-dropdownoption-disabled' : ''}`}
            onMouseEnter={this.setHighlighted}
            onMouseLeave={this.resetHighlighted}
            onClick={this.onClick}
            title={title}
          >
            {children}
          </li>
        );
      }
}

DropdownOption.propTypes = {
    onSelect: PropTypes.func,
    onClick: PropTypes.func,
    value: PropTypes.any,
    disabled: PropTypes.bool,
    
};

export default DropdownOption;